import { Button, ButtonGroup, IconButton, Stack, Tooltip } from "@mui/material"
import { If } from "lib/@components/switch"
import { isEnabled } from "lib/@components/feature"
import { hasDemand } from "lib/authorization/has-demand"
import Iconify from "minimals-template/components/Iconify"
import {
    FEATURE_FLAG_PROJECT_BRIDGE,
    PROJECT_BRIDGE_ACCESS_DEMAND,
} from "routes/plugins/project-bridge/server/feature-flag-project-bridge.mjs"

export function AuthoringRecommendationsFilterBar({
    sourceFilter,
    isRefreshingStyleGuide,
    onShowAll,
    onShowLegislation,
    onShowReviewProjects,
    onShowProjectBridge,
    onShowStyleGuide,
    onRefreshStyleGuide,
}) {
    const projectBridgeEnabled = isEnabled(FEATURE_FLAG_PROJECT_BRIDGE) && hasDemand(PROJECT_BRIDGE_ACCESS_DEMAND)
    return (
        <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center">
            <ButtonGroup size="small" disableElevation>
                <Button variant={sourceFilter === "all" ? "contained" : "outlined"} onClick={onShowAll}>
                    All
                </Button>
                <Button variant={sourceFilter === "legislation" ? "contained" : "outlined"} onClick={onShowLegislation}>
                    Legislation
                </Button>
                <Button
                    variant={sourceFilter === "reviewProject" ? "contained" : "outlined"}
                    onClick={onShowReviewProjects}
                >
                    Review Projects
                </Button>
                <If value={projectBridgeEnabled}>
                    <Button
                        variant={sourceFilter === "projectBridge" ? "contained" : "outlined"}
                        onClick={onShowProjectBridge}
                    >
                        Project Bridge
                    </Button>
                </If>
                <Button variant={sourceFilter === "styleGuide" ? "contained" : "outlined"} onClick={onShowStyleGuide}>
                    Style Guide
                </Button>
            </ButtonGroup>
            <Tooltip title="Refresh style guide recommendations">
                <span>
                    <IconButton
                        aria-label="Refresh style guide recommendations"
                        size="small"
                        color="primary"
                        onClick={onRefreshStyleGuide}
                        disabled={isRefreshingStyleGuide}
                    >
                        <Iconify icon="mdi:refresh" width={16} />
                    </IconButton>
                </span>
            </Tooltip>
        </Stack>
    )
}
